import { createFileRoute } from '@tanstack/react-router';
import { CostGroupsSettingsPage } from '../components/CostGroupsSettingsPage';

export const Route = createFileRoute('/settings/cost-groups/year-rates')({
  component: () => <CostGroupsSettingsPage section="group-rates" />,
});
